var map = {
	"./patient.jpg": "ZuuW",
	"./patient1.jpg": "r7zz",
	"./patient10.jpg": "rTHD",
	"./patient11.jpg": "+tWG",
	"./patient12.jpg": "pECe",
	"./patient13.jpg": "SCJ3",
	"./patient14.jpg": "3Qpv",
	"./patient15.jpg": "pZux",
	"./patient2.jpg": "Gac2",
	"./patient3.jpg": "PpsS",
	"./patient4.jpg": "IkoD",
	"./patient5.jpg": "u5GX",
	"./patient6.jpg": "8Sgi",
	"./patient7.jpg": "5sY3",
	"./patient8.jpg": "CHyk",
	"./patient9.jpg": "OkRT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rKID";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/patients nonrecursive \.png$|\.jpg$
// module id = rKID
// module chunks = 0